export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0F172A" />
    <path
      d="M41 21.5c-2.6-3.2-7.4-4.4-11-2.6-3.7 1.8-4.3 6.4-1 8.7l10.4 6.2c3.9 2.6 3 8.3-1.6 9.7-4.2 1.3-9-.3-11.3-3.7"
      stroke="#F59E0B"
      strokeWidth="5.5"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark className="h-9 w-9" />
    <span
      className={`font-display text-lg font-extrabold tracking-tight ${
        light ? "text-white" : "text-[#0F172A]"
      }`}
    >
      Smart-In<span className="text-[#F59E0B]">.</span>
    </span>
  </span>
);
